import { getDatesFromSessions } from 'utils/session';
import { MAX_SESSIONS_PER_DAY_FOR_AVAILABILITY } from 'api/session/constants';
import useCollectionAvailableSessions, {
  PublicSessionsQueryParams,
} from './useCollectionAvailableSessions';

const useAvailableDates = (queryParams: PublicSessionsQueryParams) => {
  const { sessions, isLoadingSessions } = useCollectionAvailableSessions({
    maxSessionsPerDay: MAX_SESSIONS_PER_DAY_FOR_AVAILABILITY,
    ...queryParams,
  });

  return {
    availableDates: getDatesFromSessions(sessions),
    isLoadingAvailableDates: isLoadingSessions,
  };
};

export default useAvailableDates;
